
function subscribe(eventName: string, listener: EventListener) {
    document.addEventListener(eventName, listener);
}

function unSubscribe(eventName: string, listener: EventListener) {
    document.removeEventListener(eventName, listener);
}

function publish(eventName: string, data: string) {
    const event = new CustomEvent(eventName, { detail: data });
    document.dispatchEvent(event);
}

const customApiError = "custom:webApiError";
const customOtherError = "custom:otherError";

function subscribeToErrors(listener: EventListener) {
    subscribe(customApiError, listener);
    subscribe(customOtherError, listener);
}

function unSubscribeFromErrors(listener: EventListener) {
    unSubscribe(customApiError, listener);
    unSubscribe(customOtherError, listener);
}

function publishApiError(data: string) {
    publish(customApiError, data);
}

function publishCustomError(data: string) {
    publish(customOtherError, data);
}

export { subscribeToErrors, unSubscribeFromErrors, publishApiError, publishCustomError, customApiError, customOtherError};